import { createStore } from 'zustand-x';

// 1. Define your store state types
interface PushNotificatioStoreState {
  isLaunchedOnLogout: boolean;
  notificationLaunchUrl: string;
}

// 2. Create the store with strong typing
export const pushNotificatioStore = createStore('pushNotification')<PushNotificatioStoreState>(
  {
    isLaunchedOnLogout: false,
    notificationLaunchUrl: '/app/home',
  },
  { devtools: { enabled: true } }
).extendActions((set) => ({
  setNotificationLaunchUrl: (url: string) => {
    set.state((state) => ({
      ...state,
      notificationLaunchUrl: url,
    }));
  },
  setIsLaunchedOnLogout: (value: boolean) => {
    set.state((state) => ({
      ...state,
      isLaunchedOnLogout: value,
    }));
  },
}));
